(function () {
    'use strict';

    angular
        .module('emails')
        .controller('TokenLetterController', TokenLetterController);

    TokenLetterController.$inject = ['$scope','$uibModal','$compile','toastr','VirtualFairService'];

    function TokenLetterController($scope,$uibModal,$compile,toastr,VirtualFairService) {
        const vm = this;
        vm.query  = {};
        vm.type = new Map([
            [1, 'token'],
            [2, 'token2hours'],
            [3, 'tokenLastChance']
        ]);
        vm.events = [];
        vm.flag = false;
        vm.getAll = getAll;
        vm.toSchedule = toSchedule;
        vm.toRegistration = toRegistration;
        vm.openTokenLetterModal = openTokenLetterModal;

        function activate(){
            vm.getAll();
        }
        function getAll() {
            VirtualFairService.getEventsByNow().then(function(response){
                if(response.data.length)
                    vm.flag = true;
                vm.events = response.data;
            }).catch(function(err) {
            });
        }

        function toSchedule(expoId, typeId) {
            vm.query = {
                expo_id: expo_id,
                letter_type: vm.type.get(typeId)
            }
        }

        function toRegistration(registrationType) {
            vm.query.registration_type = registrationType;
        }

        function openTokenLetterModal(event) {
            $uibModal.open({
                templateUrl: 'templates/emails/token_letter/modal/template.modal.html',
                controller: 'tokenLetterModalController',
                controllerAs:'vm',
                resolve:
                    {
                        event : function () {
                            return event;
                        }
                    }
            });
        }
        activate();
    }
})();